<div class="background w-100 h-100">
  <div class="brand-wrapper">
    <div class="flex-container" fxLayout="column" fxLayoutAlign="center center">
      <div class="mb-5 pb-3" fxLayout="column" fxLayoutAlign="center center" >
        <img class="img-fluid" src="/assets/logo/handle02.png">
      </div>

      <div class="title text-center pl-3">Maker World</div>
      <div class="subtitle text-center pb-3">Maker Jun의 강의홈페이집니다.</div>
      <button mat-raised-button routerLink="/courses" class="mt-3 my-3 mx-auto d-block">GET STARTED</button>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/pages/intro/intro.component.html